import * as _Color from 'color';

export const Color: any = _Color;
